type QueryParamPrimitive = string | number | boolean;
type QueryParamValue = QueryParamPrimitive | readonly QueryParamPrimitive[] | null | undefined;
export type QueryParams = Record<string, QueryParamValue>;

export class QueryStringBuilder {
	static build(params: QueryParams): string {
		const searchParams = new URLSearchParams();

		for (const [key, value] of Object.entries(params)) {
			if (value === null || value === undefined) continue;

			if (Array.isArray(value)) {
				for (const item of value) {
					searchParams.append(`${key}[]`, String(item));
				}
				continue;
			}

			searchParams.set(key, String(value));
		}

		return searchParams.toString();
	}
}
